<template>
    <div v-if="integrations" class="table-integration p-3">
        <vs-alert v-if="sendLeadError" title="Error" active="true" color="danger" class="mb-3">
            <div class="flex items-start">
                <vs-icon
                    class="mr-2 cursor-pointer"
                    color="primary"
                    v-tooltip="$t('tooltip.Copy')"
                    @click.stop.prevent="copy(sendLead.full_message)"
                    v-bind="$iconData('icon-copy', 'fi-rr-copy-alt')"
                />

                <div>
                    <div>Advertiser: {{sendLead.advertiser_name}}</div>
                    <div>Message: {{sendLead.message}}</div>
                </div>
            </div>
        </vs-alert>

        <div v-for="(item) in arrayTable" :key="item.table" class="mb-4">
            <h2 class="table-integration__title">{{$t(item.title)}}</h2>
            <ds-table
                :data="integrations[item.table]"
                :heads="heads[item.table]"
                :max-items="10"
                :view-items="[10, 15, 20]"
                spacer
                search
                content-center
            >
                <template v-slot:advertiser_name="{advertiser_name}">
                    {{ advertiser_name.advertiser_name || advertiser_name.advertiser_id || '-' }}
                </template>

                <template v-slot:start="{start}">
                    {{ start.cap_cc_work_start }}
                </template>

                <template v-slot:end="{end}">
                    {{ end.cap_cc_work_end }}
                </template>

                <template v-slot:offers="{offers}">
                    <div
                        v-if="(offers.offers_accepted || []).length"
                        v-for="(offer, index) of offers.offers_accepted"
                        :key="index"
                    >
                        <span class="whitespace-no-wrap">{{offer}}</span>
                    </div>
                </template>

                <template v-slot:countries="{countries}">
                    <div
                        v-if="_isJSON(countries.team_countries)"
                        v-for="(country, index) of _isJSON(countries.team_countries)"
                        :key="index"
                        class="flex items-center justify-start whitespace-no-wrap"
                    >
                        <div style="width: 30px;">
                            <flag width="25" :iso="country" type="country"/>
                        </div>
                        <span class="ml-2">{{country}}</span>
                    </div>
                </template>

                <template v-slot:hot="{hot}">
                    <div class="text-center">
                        <vs-icon v-if="hot.is_hot" color="success" v-bind="$iconData('icon-check', 'fi-rr-check')"></vs-icon>
                        <vs-icon v-else color="danger" v-bind="$iconData('icon-x', 'fi-rr-cross-small')"></vs-icon>
                    </div>
                </template>

                <template v-slot:teams_int_status="{teams_int_status}">
                    <div class="flex justify-center">
                        <vs-chip style="width: 150px;" transparent :color="teams_int_status.team_integration_is_active ? 'success' : 'danger'">
                            {{ teams_int_status.team_integration_is_active ? 'Active' : 'Inactive' }}
                        </vs-chip>
                    </div>
                </template>

                <template v-slot:adv_status="{adv_status}">
                    <div class="flex justify-center">
                        <vs-chip style="width: 150px;" transparent :color="adv_status.advertiser_is_active ? 'success' : 'danger'">
                            {{ adv_status.advertiser_is_active ? 'Active' : 'Inactive' }}
                        </vs-chip>
                    </div>
                </template>

                <template v-slot:integration_status="{integration_status}">
                    <div class="flex justify-center">
                        <vs-chip style="width: 150px;" transparent :color="integration_status.integration_is_active ? 'success' : 'danger'">
                            {{ integration_status.integration_is_active ? 'Active' : 'Inactive' }}
                        </vs-chip>
                    </div>
                </template>

                <template v-slot:actions="{actions}">
                    <div>
                        <vs-button
                            v-if="!sendLead.sended"
                            v-can="'statistic_lead.send_hold_lead'"
                            @click="forceSendLead(actions)"
                            v-tooltip="$t('buttons.ForceSendLead')"
                            v-bind="$iconData('icon-send', 'fi-rr-paper-plane-top')"
                            type="flat"
                            radius
                        ></vs-button>

                        <vs-button
                            v-if="sendLead.sended && actions.integration_id === sendLead.integration_id"
                            :disabled="!sendLead.redirect_url"
                            v-can="'statistic_lead.send_hold_lead'"
                            :href="sendLead.redirect_url"
                            target="_blank"
                            v-tooltip="$t('buttons.OpenNew')"
                            v-bind="$iconData('icon-share', 'fi-rr-share-square')"
                            type="flat"
                            radius
                        ></vs-button>
                    </div>
                </template>
            </ds-table>
        </div>
    </div>
</template>

<script>
import send from '@/utils/fetch'
import {copy} from "@/utils/utils"
import ErrorHandler from "@/utils/errorHandler";
import EventBus from "@/store/eventBus";

export default {
    name: 'InfoIntegration',
    data() {
        return {
            timeout: null,
            sendLeadError: false,
            sendLead: {
                sended: false,
                redirect_url: null
            },
            integrations: null,
            headsTemplate: [
                {name: 'modals.Advertiser_name', key: 'advertiser_name', sortKey: 'advertiser_name', value: 'advertiser_name', display: true},
                {name: 'global.Integration', key: 'integration_name', sortKey: 'integration_name', value: 'integration_name', display: true},
                {name: 'global.Offers', key: 'offers', sortKey: 'team_offers_accepted', value: 'offers', display: true},
                {name: 'global.CapsByCountry', key: 'countries', value: 'country_cap_remainder', display: true},
                {name: 'global.CapsByGeo', key: 'cap_remainder', sortKey: 'cap_remainder', value: 'cap_remainder', display: true},
                {name: 'global.Start', key: 'start', sortKey: 'cap_cc_start', value: 'start', display: true},
                {name: 'global.End', key: 'end', sortKey: 'cap_cc_end', value: 'end', display: true},
                {name: 'modals.Hot', key: 'hot', sortKey: 'is_hot', value: 'hot', display: true},
                {name: 'modals.Team_status', key: 'teams_int_status', sortKey: 'team_integration_is_active', value: 'teams_int_status', display: true},
                {name: 'statistic.Advertiser_status', key: 'adv_status', sortKey: 'adv_is_active', value: 'adv_status', display: true},
                {name: 'global.Integration_Status', key: 'integration_status', sortKey: 'integration_is_active', value: 'integration_status', display: true},
                {name: 'global.Actions', key: 'actions', value: 'actions', can: 'statistic_lead.send_hold_lead', display: true},
            ],
            heads: {},
            arrayTable: [
                {table: 'active', title: 'global.active', class: 'active'},
                {table: 'inactive', title: 'global.inactive', class: 'inactive'},
                {table: 'by_geo', title: 'global.byGeo', class: 'byGeo'},
                {table: 'all', title: 'global.All', class: ''},
            ]
        }
    },

    props: {
        popupData:{
            type: Number,
        }
    },

    methods: {
        clearAlert() {
            this.sendLeadError = false
            this.sendLead.message = null
        },

        copy(data) {
            copy(JSON.stringify(data))

            this.$vs.notify({
                title: 'Success!',
                text: this.$t('notification.success'),
                color: 'success',
                iconPack: 'feather',
                icon: 'icon-check'
            })
        },

        async forceSendLead(data) {
            clearTimeout(this.timeout)
            this.clearAlert()

            const response = await send(this.$url.statistic.send, 'POST', {
                data: {advertiser_integration_id: data.integration_id, id: this.popupData}
            },false).then(response => response.data)

            if (response.success) {
                this.sendLead = {
                    ...this.sendLead,
                    ...response.result,
                    sended: true,
                    integration_id: data.integration_id
                }

                EventBus.$emit('reloadTable')
            } else {
                this.sendLead = {
                    ...this.sendLead,
                    ...response.result
                }

                const message = () => {
                    try {
                        return JSON.parse(response.result.advertiser_response)
                    } catch (e) {
                        return response.result.advertiser_response
                    }
                }

                if (!response.result.errors) {
                    const mess = message()
                    const m = mess && mess.error ? mess.error.message : mess

                    this.sendLead.full_message = `Advertiser : ${data.advertiser_name} \nMessage: ${JSON.stringify(m)}`
                    this.sendLead.message = m
                } else {
                    this.sendLead.full_message = `Advertiser : ${data.advertiser_name} \nMessage: ${JSON.stringify(response.result.errors)}`
                    this.sendLead.message = response.result.errors
                }

                this.sendLead.advertiser_name = data.advertiser_name

                this.sendLeadError = true

                await this.get()
            }
        },

        _isJSON(json) {
            try {
                return JSON.parse(json)
            } catch (e) {
                return false
            }
        },

        async get() {
            try {
                const removeItem = (data, key) => data.filter(item => item.value !== key)

                this.arrayTable.map(item => this.heads[item.table] = this.headsTemplate)
                Object.keys(this.heads).map(key => {
                    if (key === 'all') this.heads[key] = removeItem(this.heads[key], 'offers')
                    if (key !== 'by_geo') this.heads[key] = removeItem(this.heads[key], 'country_cap_remainder')
                    if (key !== 'active') this.heads[key] = removeItem(this.heads[key], 'actions')
                })

                this.integrations = await send(`${this.$url.statistic.integration_by_lead}/${this.popupData}`, 'GET')
                    .then(data => data.data.result);

                Object.keys(this.integrations).map(key => {
                    this.integrations[key].forEach(item => {
                        if (key === 'active' && !item.redirect_url) {
                            item.redirect_url = null
                        }

                        if (
                            item.hasOwnProperty('country_cap_leads') &&
                            item.hasOwnProperty('country_cap_set') &&
                            item.country_cap_leads !== null &&
                            item.country_cap_set !== null
                        ) {
                            item.country_cap_remainder = ~~item.country_cap_set - ~~item.country_cap_leads
                        } else {
                            this.heads[key] = this.heads[key].filter(item => item.value !== 'country_cap_remainder')
                        }

                        item.cap_remainder = ~~item.cap_set - ~~item.cap_leads
                    })
                })
            } catch (e) {
                new ErrorHandler(e).send
            }
        }
    },

    async mounted(){
        try {
            await this.get()
            this.$store.commit('UPDATE_LOADER_STATE', false)
        } catch (e) {
            this.$store.commit('UPDATE_LOADER_STATE_SET_ERROR', true)
        }
    }

}
</script>

<style scoped lang="scss">
    .table-integration {
        &__title{
            padding-left: 9px;
            margin-bottom: 15px;
            font-size: 20px;
            font-weight: bold;
            color: #626262;
        }

        .active {
            color: #289a28;
        }

        .inactive {
            color: #d83333;
        }
    }
</style>
